import { Clock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { openBillingPortal } from "@/lib/checkout";

export function TrialBanner() {
  const { user } = useAuth();
  const t = user?.trial;
  if (!t) return null;
  return (
    <div data-testid="trial-banner" className="bg-[var(--accent)] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-2.5 flex items-center justify-between gap-3 text-sm">
        <span className="flex items-center gap-2">
          <Clock className="w-4 h-4 shrink-0" />
          <span><strong>{t.days_left} day{t.days_left === 1 ? "" : "s"} left</strong> in your {t.plan} free trial — no charge until it ends.</span>
        </span>
        {user?.has_billing && (
          <button data-testid="trial-manage" onClick={() => openBillingPortal().catch(() => {})} className="underline underline-offset-2 hover:opacity-90 whitespace-nowrap shrink-0">
            Manage billing
          </button>
        )}
      </div>
    </div>
  );
}
